/**
 * =====================================================
 * OPTIMIZACIÓN REVIEWS REVIE - FACTORYTECH.CL
 * Versión 3.0 - Estructura real de Electbox v1.7.0
 *
 * Estructura confirmada del tema:
 *   ul.tabs > li > a[href="#tab-1"] (Descripción)
 *              li > a[href="#tab-2"] (Comentarios)
 *   .tab-container > div#tab-1
 *                    div#tab-2
 *   #cont-rl-w (dentro de product__info-container--sticky)
 * =====================================================
 */

(function () {
  'use strict';

  var CONFIG = {
    tabLabel: 'Opiniones',
    newTabId: 'tab-reviews-ft',
    waitTimeout: 10000,
    checkInterval: 300
  };

  function log(msg) {
    console.log('[FactoryTech v3] ' + msg);
  }

  /* ------------------------------------------------
     1. ESPERAR QUE EL DOM ESTÉ LISTO
  ------------------------------------------------ */
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ------------------------------------------------
     2. ENCONTRAR EL WIDGET DE REVIE
  ------------------------------------------------ */
  function findRevie() {
    return document.querySelector('#cont-rl-w') ||
           document.querySelector('[id^="cont-rl"]') ||
           document.querySelector('[id*="revie-widget"]');
  }

  /* ------------------------------------------------
     3. CONTAR REVIEWS EN EL WIDGET
  ------------------------------------------------ */
  function countReviews(revieEl) {
    var candidates = revieEl.querySelectorAll(
      '[class*="rl-review"], [class*="review-item"], [class*="revie-review"], .rl-item'
    );
    return candidates.length;
  }

  /* ------------------------------------------------
     4. MOVER REVIE A UN NUEVO TAB
  ------------------------------------------------ */
  function moveRevieToTabs(revieEl) {
    var tabsList     = document.querySelector('ul.tabs');
    var tabContainer = document.querySelector('.tab-container');

    if (!tabsList || !tabContainer) {
      log('ul.tabs o .tab-container no encontrado — abortando JS.');
      return false;
    }

    if (document.getElementById(CONFIG.newTabId)) {
      log('Tab de opiniones ya existe.');
      return true;
    }

    /* 4a. Crear li > a en la navegación */
    var count     = countReviews(revieEl);
    var badgeHTML = count > 0
      ? ' <span class="reviews-count-badge">' + count + '</span>'
      : '';

    var li = document.createElement('li');
    var a  = document.createElement('a');
    a.href = '#' + CONFIG.newTabId;
    a.innerHTML = CONFIG.tabLabel + badgeHTML;
    li.appendChild(a);
    tabsList.appendChild(li);

    /* 4b. Crear div#tab-reviews-ft en .tab-container */
    var pane = document.createElement('div');
    pane.id            = CONFIG.newTabId;
    pane.className     = 'tab-pane-reviews';
    pane.style.display = 'none';

    var wrapper = document.createElement('div');
    wrapper.className = 'ft-reviews-scroll-wrapper';
    revieEl.setAttribute('data-ft-moved', 'true'); // Desactiva CSS fallback
    wrapper.appendChild(revieEl);
    pane.appendChild(wrapper);
    tabContainer.appendChild(pane);

    /* 4c. Ocultar el app-block original que contenía a Revie */
    /* Buscamos el shopify-app-block ancestro por ID conocido */
    var originalBlock = document.getElementById(
      'shopify-block-AQ0lRdlNSazJwV1NvQ__revie_reviews_por_whatsapp_app_block_2_8bH9b9'
    );
    if (originalBlock) {
      originalBlock.style.display = 'none';
      log('App-block original ocultado.');
    } else {
      /* Fallback: ocultar el padre inmediato de donde estaba #cont-rl-w */
      /* En este punto revieEl ya está en el nuevo pane, así que recorremos
         hacia arriba desde el pane buscando el shopify-app-block vacío */
      var vacioBlock = document.querySelector(
        '.product__info-container .shopify-app-block:empty, ' +
        '.product__info-container--sticky .shopify-app-block:empty'
      );
      if (vacioBlock) {
        vacioBlock.style.display = 'none';
        log('App-block vacío ocultado (fallback).');
      }
    }

    log('Widget Revie movido a #' + CONFIG.newTabId + ' correctamente.');
    return true;
  }

  /* ------------------------------------------------
     5. VINCULAR CLICKS DE TABS
        Electbox: ul.tabs > li > a[href="#tab-X"]
        .tab-container > div con id correspondiente
  ------------------------------------------------ */
  function bindTabClicks() {
    /* Re-clonar todos los links para limpiar handlers de Electbox */
    document.querySelectorAll('ul.tabs a').forEach(function (link) {
      var clone = link.cloneNode(true);
      link.parentNode.replaceChild(clone, link);

      clone.addEventListener('click', function (e) {
        e.preventDefault();

        /* Desactivar todos */
        document.querySelectorAll('ul.tabs a').forEach(function (l) {
          l.classList.remove('active');
        });
        document.querySelectorAll('.tab-container > div').forEach(function (p) {
          p.style.display = 'none';
        });

        /* Activar el clickeado */
        clone.classList.add('active');
        var targetId = clone.getAttribute('href').replace('#', '');
        var target   = document.getElementById(targetId);
        if (target) {
          target.style.display = 'block';
        }
      });
    });

    log('Clicks de tabs vinculados (' +
      document.querySelectorAll('ul.tabs a').length + ' tabs).');
  }

  /* ------------------------------------------------
     6. ESPERAR A REVIE Y EJECUTAR
  ------------------------------------------------ */
  function waitAndRun() {
    var elapsed = 0;

    var timer = setInterval(function () {
      elapsed += CONFIG.checkInterval;

      var revieEl = findRevie();

      if (revieEl) {
        clearInterval(timer);
        log('Revie encontrado (' + elapsed + 'ms). Procesando...');
        var moved = moveRevieToTabs(revieEl);
        if (moved) {
          setTimeout(bindTabClicks, 80);
        }
      } else if (elapsed >= CONFIG.waitTimeout) {
        clearInterval(timer);
        log('Timeout: Revie no encontrado. CSS fallback activo.');
      }
    }, CONFIG.checkInterval);
  }

  /* ------------------------------------------------
     7. API PÚBLICA
  ------------------------------------------------ */
  window.FactoryTechReviews = {
    debug: function () {
      log('Revie widget: ' + (findRevie() ? 'ENCONTRADO' : 'NO'));
      log('ul.tabs: ' + (document.querySelector('ul.tabs') ? 'ENCONTRADO' : 'NO'));
      log('.tab-container: ' + (document.querySelector('.tab-container') ? 'ENCONTRADO' : 'NO'));
      log('Tab reviews: ' + (document.getElementById(CONFIG.newTabId) ? 'CREADO OK' : 'NO CREADO'));
    },
    refresh: waitAndRun
  };

  /* ------------------------------------------------
     8. ARRANQUE
  ------------------------------------------------ */
  onReady(waitAndRun);

  log('Script v3 cargado.');

})();
